import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  paymentError: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  cardElementContainer: {
    position: 'relative',
    marginBottom: theme.spacing(0),
    '& .StripeElement': {
      width: '100%',
      height: '48px',
      padding: '0 14px',
      border: `1px solid ${theme.oysterTheme.stone}`,
      borderRadius: 8,
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      transition: theme.transitions.create(['border-color']),
      '& > div': {
        flex: 1,
      },
      '& iframe': {
        opacity: 1,
        color: theme.oysterTheme.charcoal,
      },
      '&--focus': {
        borderColor: theme.oysterTheme.stone,
        '& + $inputLabel': {
          color: theme.oysterTheme.shark,
          transform: 'translate(14px, -25%) scale(0.75)',
          backgroundColor: theme.palette.background.paper,
        },
      },
      '&--invalid': {
        borderColor: theme.oysterTheme.ferrari,
        '& + $inputLabel': {
          color: theme.oysterTheme.ferrari,
        },
      },
    },
    '&.has-error .StripeElement': {
      borderColor: theme.oysterTheme.ferrari,
      '& + $inputLabel': {
        color: theme.oysterTheme.ferrari,
      },
    },
    '&.has-content': {
      '& .StripeElement + $inputLabel': {
        transform: 'translate(14px, -25%) scale(0.75)',
        backgroundColor: theme.palette.background.paper,
      },
    },
    '&.brand-visa .StripeElement': {
      backgroundImage:
        'url(https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg)',
      backgroundPosition: 'right 14px center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto 60%',
      '& > div': {
        paddingRight: '50px',
      },
    },
    '&.brand-mastercard .StripeElement': {
      backgroundImage:
        'url(https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg)',
      backgroundPosition: 'right 14px center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto 60%',
      '& > div': {
        paddingRight: '50px',
      },
    },
    '&.brand-amex .StripeElement': {
      backgroundImage:
        'url(https://js.stripe.com/v3/fingerprinted/img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg)',
      backgroundPosition: 'right 14px center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto 60%',
      '& > div': {
        paddingRight: '50px',
      },
    },
    '&.is-processing': {
      opacity: 0.7,
      pointerEvents: 'none',
      '& .StripeElement': {
        borderColor: theme.oysterTheme.shark,
      },
    },
  },
  inputLabel: {
    position: 'absolute',
    left: 0,
    top: 0,
    transform: 'translate(14px, 14px)',
    fontSize: '1rem',
    color: theme.oysterTheme.extraGrey,
    transition: theme.transitions.create(['transform', 'color', 'background-color']),
    transformOrigin: 'left top',
    pointerEvents: 'none',
    padding: '0 4px',
    zIndex: 1,
  },
  formRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2.5),
    gap: theme.spacing(2.5),
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));
